import { PlaylistAssignPanel } from '../features/playlistAssignments/components/PlaylistAssignPanel';
import { CLOSE_DESTINATION_PARAM, getAssignmentsForPortalUrl, getPortalAssignmentsUrl } from '../features/playlistAssignments/playlistAssignmentsRouting';
import { usePlaylistAssignmentsParams } from '../features/playlistAssignments/playlistAssignmentsHooks';
import useNavigate from '../hooks/useNavigate';
import { NavMarker } from 'react-rhumb';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../hooks/searchParamHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignPlaylist = () => {
  const {
    portalId,
    assignmentIds,
    playlistId
  } = usePlaylistAssignmentsParams();
  const [[closeDestinationParam]] = useSearchParam(CLOSE_DESTINATION_PARAM);
  const navigate = useNavigate();
  const defaultCloseDestination = portalId ? getAssignmentsForPortalUrl({
    portalId,
    playlistId
  }) : getPortalAssignmentsUrl({
    playlistId
  });
  const closeDestination = closeDestinationParam || defaultCloseDestination;
  return /*#__PURE__*/_jsx(PlaylistAssignPanel, {
    assignmentIds: assignmentIds,
    loadedNavMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "ASSIGN_PLAYLIST_LOADED"
    }),
    onClose: () => navigate(closeDestination, {
      method: 'replace'
    }),
    onSuccess: () => navigate(closeDestination, {
      method: 'replace'
    }),
    playlistId: playlistId,
    portalId: portalId
  });
};
export default AssignPlaylist;